export default __webpack_public_path__ + "static/media/logo-header@2x.0d4e36ab.png";